export default __webpack_public_path__ + "favicon-16x16.35c5ded8.png";